import Hero from "@/sections/Hero";
import Subjects from "@/sections/Subjects";
import Manifesto from "@/sections/Manifesto";
import Teachers from "@/sections/Teachers";
import Pricing from "@/sections/Pricing";
import Testimonials from "@/sections/Testimonials";
import CtaBanner from "@/sections/CtaBanner";
import { EditorialMarquee } from "@/components/Marquee";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <EditorialMarquee />
            <Subjects />
            <Manifesto />
            <Teachers />
            <Pricing />
            <Testimonials />
            <CtaBanner />
        </main>
    );
}
